import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ChangeWorkoutPage } from 'pages/change-workout-page/change-workout-page';

@NgModule({
  declarations: [ChangeWorkoutPage],
  imports: [PagesModule, ComponentsModule],
  exports: [ChangeWorkoutPage]
})
export class ChangeWorkoutPageModule { }
